module.exports = __webpack_public_path__ + "static/img/3_5.eb2c87f0.jpg";